module.exports = __webpack_public_path__ + "static/media/transform-icon-active.25a4cb1d.svg";